// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forecast-boxes-table {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.forecast-boxes-table__upper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
}
.forecast-boxes-table__upper__controls {
  display: flex;
  flex-direction: row;
  justify-content: end;
  height: fit-content;
  gap: 0.5rem;
}
.forecast-boxes-table__upper__controls__add-button {
  width: fit-content;
  height: 40px;
  background-color: #4F4BFF;
  color: white;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.forecast-boxes-table__upper__controls__filter-button {
  width: fit-content;
  height: 40px;
  background-color: transparent;
  color: black;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
}
.forecast-boxes-table__table {
  height: 55vh;
  overflow-y: auto;
}
.forecast-boxes-table__table__header {
  padding: 10px 1.5rem 10px 1rem;
  display: grid;
  grid-template-columns: 40% 20% 20% 20%;
  place-items: center;
  background-color: #F9FAFB;
  border-radius: 7px;
  height: 8%;
  font-size: 0.85rem;
}
.forecast-boxes-table__table__header div:nth-child(1) {
  justify-self: start;
  padding-left: 1rem;
}
.forecast-boxes-table__table__body {
  height: 82%;
  overflow-y: auto;
}
.forecast-boxes-table__lower-controls {
  height: fit-content;
  display: flex;
  flex-direction: row;
  justify-content: end;
  align-items: center;
}
.forecast-boxes-table__lower-controls__rows-per-page, .forecast-boxes-table__lower-controls__visible-rows {
  font-size: 0.85rem;
  color: #64748B;
  margin-right: 75px;
}
.forecast-boxes-table__lower-controls__button {
  width: 110px;
  height: 40px;
  background-color: transparent;
  color: #726BEA;
  border-color: #DEDEDE;
  border-radius: 6px;
  font-size: 0.85rem;
  margin-right: 10px;
}
.forecast-boxes-table__lower-controls .disabled {
  color: #DEDEDE;
  pointer-events: none;
}
.forecast-boxes-table__filter-container {
  position: relative;
}
.forecast-boxes-table__filter-container .filters-active {
  background-color: #4F4BFF;
  color: white;
}
.forecast-boxes-table__filter-container .filters-active:hover {
  background-color: #3f3ccc;
}
.forecast-boxes-table__filters-popup {
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  padding: 1rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  max-height: 300px;
  overflow-y: auto;
}
.forecast-boxes-table__filters-popup__item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  cursor: pointer;
}
.forecast-boxes-table__filters-popup__item label {
  cursor: pointer;
  margin-left: 0.5rem;
}
.forecast-boxes-table__filters-popup__item:hover {
  background: #f5f5f5;
}

.p-checkbox.p-highlight .p-checkbox-box {
  background-color: #4F4BFF;
}`, "",{"version":3,"sources":["webpack://./src/features/profile/components/forecast-boxes-table/forecast-boxes-table.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AACJ;AAAI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,gBAAA;AAER;AADQ;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AAGZ;AAFY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAIhB;AADY;EACI,kBAAA;EACA,YAAA;EACA,6BAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;AAGhB;AACI;EACI,YAAA;EACA,gBAAA;AACR;AAAQ;EACI,8BAAA;EAEA,aAAA;EACA,sCAAA;EACA,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AACZ;AAAY;EACI,mBAAA;EACA,kBAAA;AAEhB;AACQ;EACI,WAAA;EACA,gBAAA;AACZ;AAEI;EACI,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,mBAAA;AAAR;AAEQ;EAEI,kBAAA;EACA,cAAA;EACA,kBAAA;AADZ;AAIQ;EACI,YAAA;EACA,YAAA;EACA,6BAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;AAFZ;AAIQ;EACI,cAAA;EACA,oBAAA;AAFZ;AAKI;EACI,kBAAA;AAHR;AAKQ;EACI,yBAAA;EACA,YAAA;AAHZ;AAKY;EACI,yBAAA;AAHhB;AAOI;EACI,kBAAA;EACA,qBAAA;EACA,QAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,wCAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AALR;AAOQ;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;AALZ;AAOY;EACI,eAAA;EACA,mBAAA;AALhB;AAQY;EACI,mBAAA;AANhB;;AAYA;EACI,yBAAA;AATJ","sourcesContent":[".forecast-boxes-table{\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    &__upper{\n        display: flex;\n        flex-direction: row;\n        justify-content: space-between;\n        align-items: end;\n        &__controls{\n            display: flex;\n            flex-direction: row;\n            justify-content: end;\n            height: fit-content;\n            gap: 0.5rem;\n            &__add-button{\n                width: fit-content;\n                height: 40px;\n                background-color:#4F4BFF;\n                color: white;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n\n            &__filter-button{\n                width: fit-content;\n                height: 40px;\n                background-color:transparent;\n                color: black;\n                border-color: #DEDEDE;\n                border-radius: 6px;\n                font-size: 0.85rem;\n            }\n        }\n    }\n    &__table{\n        height: 55vh;\n        overflow-y:auto;\n        &__header{\n            padding: 10px 1.5rem 10px 1rem;\n            \n            display: grid;\n            grid-template-columns: 40% 20% 20% 20%;\n            place-items: center;\n            background-color: #F9FAFB;\n            border-radius: 7px;\n            height: 8%;\n            font-size: 0.85rem;\n            div:nth-child(1) {  // FLAVORS column\n                justify-self: start;\n                padding-left: 1rem;\n            }\n        }\n        &__body{\n            height: 82%;\n            overflow-y: auto;\n        }\n    }\n    &__lower-controls{\n        height: fit-content;\n        display: flex;\n        flex-direction: row;\n        justify-content: end;\n        align-items: center;\n\n        &__rows-per-page,\n        &__visible-rows{\n            font-size: 0.85rem;\n            color: #64748B;\n            margin-right: 75px;\n        }\n        \n        &__button{\n            width: 110px;\n            height: 40px;\n            background-color:transparent;\n            color: #726BEA;\n            border-color: #DEDEDE;\n            border-radius: 6px;\n            font-size: 0.85rem;\n            margin-right: 10px;\n        }\n        .disabled{\n            color: #DEDEDE;\n            pointer-events: none;\n        }\n    }\n    &__filter-container {\n        position: relative;\n        \n        .filters-active {\n            background-color: #4F4BFF;\n            color: white;\n            \n            &:hover {\n                background-color: #3f3ccc;\n            }\n        }\n    }\n    &__filters-popup {\n        position: absolute;\n        top: calc(100% + 5px);\n        right: 0;\n        background: white;\n        border: 1px solid #ddd;\n        border-radius: 4px;\n        padding: 1rem;\n        box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n        z-index: 1000;\n        min-width: 200px;\n        max-height: 300px;\n        overflow-y: auto;\n\n        &__item {\n            display: flex;\n            align-items: center;\n            gap: 0.5rem;\n            padding: 0.5rem;\n            cursor: pointer;\n\n            label {\n                cursor: pointer;\n                margin-left: 0.5rem;\n            }\n\n            &:hover {\n                background: #f5f5f5;\n            }\n        }\n    }\n}\n\n.p-checkbox.p-highlight .p-checkbox-box{\n    background-color: #4F4BFF ;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
